import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import SchemeAccountList from '../../../components/Multi/ChildSchemeAccount/SchemeAccountList';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';
import MainFilter from '../../../components/Tools/MainFilter';
import DashboardFilter from '../../Dashboard/components/DashboardFilter';

const emptyFilter = {
    searchStr: "",
    fromDate: "",
    toDate: "",
    dateColumn: "",
    department_id: "",
    tier: "",
    district_id: "",
    district_name: "",
};

const SchemeAccountListPage = () => {
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [open, setOpen] = useState(false);
    const [filterPayload, setFilterPayload] = useState(emptyFilter);
    const [filterApplied, setFilterApplied] = useState(emptyFilter);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setFilterPayload(filterApplied);
        setOpen(false);
    };
    const handleFilterClick = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };
    
    const handleInput = async (e) => {
      const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        setFilterApplied((prev) => {
            const newPayload = {
                ...prev,
                [name]: "",
            };
            if (name === "district_id") {
                newPayload.district_name = "";
            }
            setFilterPayload(newPayload);
            return newPayload;
        });
    }

    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Child Scheme Accounts</h4>
                        <CustomBreadcrumbs linksArray={[]} title="Child Scheme Accounts"/>
                    </div>
                </div>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterApplied} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <SchemeAccountList
                    searchStr={filterApplied.searchStr}
                    tier={filterApplied.tier}
                    district_id={filterApplied.district_id}
                />
            </div>
            { authData.user.user_type === 'l3' && <CreateButton title={"Add Child Scheme Account"} url={"/addchildSchemeAccount"}/> }
            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen}
                filterPayload={filterPayload}
                handleFilterClick={handleFilterClick}
                isDepartmentRequired={false}
            />
        </div>
    )
}
export default SchemeAccountListPage
